import { result } from 'lodash/object';
import { titleCase } from 'change-case';

import { trimMoney } from 'utils/strings';

import Insurances from 'app/collections/insurances';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import SelectorView from 'app/views/selector_view';

import { List as ListView, Heading } from 'app/components/list/list';
import TrackingCodeHeadingView from 'app/components/list/item/headings/tracking_code';
import DateAndTimeHeadingView from 'app/components/list/item/headings/date_and_time';
import ListSearchView from 'app/components/list/search';
import PageHeaderView from 'app/components/page_header';

import tmpl from './template';

export const buildHeadings = () => {
  return [
    new Heading({
      subView: m => new DateAndTimeHeadingView({ model: m }),
      display: 'Date',
      xsSize: 5,
      smSize: 2,
      wrapperClass: 'text-nowrap'
    }),
    new Heading({
      text: m => result(m.get('to_address'), 'nameAndCompany'),
      display: 'To',
      smSize: 3,
      xsHidden: true
    }),
    new Heading({
      subView: m => new TrackingCodeHeadingView({ model: m.get('tracker') }),
      display: 'Tracking Code',
      smSize: 3,
      xsHidden: true
    }),
    new Heading({
      text: m => {
        const currencyCode = 'USD';
        const amount = m.get('amount');
        return amount ? trimMoney(amount, currencyCode) : '';
      },
      display: 'Amount',
      xsSize: 4,
      smSize: 1,
    }),
    new Heading({
      text: m => {
        const status = m.get('status');
        return status ? titleCase(status) : undefined;
      },
      display: 'Status',
      wrapperClass: m => m ? 'monospace-font' : '',
      xsSize: 3,
      smSize: 1,
    }),
  ];
};

export const buildShowDetails = () => {
  return {
    mainHeading: m => m.get('id'),
  };
};

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'insurances',

  initialize({ apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATETIME });
    this.collection = new Insurances([], { apiModeSelection: this.apiModeSelection, dateRange: this.dateRange });

    this.listenTo(this.collection, 'update', this.render);

    this.addSubview('header', 'header', new PageHeaderView({
      name: 'Insurance', links: [
        { name: 'Docs', href: '/docs/api#insurance' },
        { name: 'Guide', href: '/shipping-insurance-guide' },
      ],
    }));
    this.addSubview('apiModeSelector', '#api_mode_selector', new SelectorView({ model: this.apiModeSelection }));
    this.addSubview('datepickers', '#insurance_daterange_pickers', new DatepickerRangeView({ model: this.dateRange }));
    this.addSubview('search', '#insurance_search', new ListSearchView({
      collection: this.collection, placeholder: '(ID, Reference, or Tracking Code)'
    }));
    this.addSubview('insuranceList', '#insurance_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      noResultsMessage: 'No insurance has been purchased matching your filter set.',
      showDetails: buildShowDetails(),
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/insurances/index.js